import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

// Orbit design system. tokens.css defines the :root variables and base resets;
// orbit.css defines the component vocabulary, `o-` prefixed so it cannot clash
// with the CSS the legacy Dashboard pages and the SQL editor inject.
import './shared/styles/tokens.css';
import './shared/styles/orbit.css';
import './shared/styles/charts.css';
// The Hub landing page only — scoped under `.o-hub-root`, loaded last so its
// hub-local variables win inside that subtree.
import './shared/styles/hub.css';

// The legacy Campaign page still brings its own design-system CSS via a <style>
// block; the old index.css remains unloaded (it is dead code, retired in Phase 7).

// No StrictMode: the embedded legacy pages run imperative DOM/Chart.js code that
// isn't double-invoke safe (StrictMode would mount → cleanup → mount and clash on
// canvas reuse). Production renders once regardless.
ReactDOM.createRoot(document.getElementById('root')).render(<App />);
